export const projectData = [{
    "title": "Supervised Machine Learning: Siamese Networks for Quora Question Pair Detection",
    "content": `Lorem ipsum dolor, sit amet consectetur adipisicing elit. Quis sapiente 
    laborum cupiditate possimus labore, hic temporibus velit dicta earum
    suscipit commodi eum enim atque at? Et perspiciatis dolore iure
    voluptatem.`,
    "link": "https://github.com/pennhanlee/CS3244-Quora-Semantics-Project"
}, {
    "title": "Inzaghi, Bird Detection using Computer Vision",
    "content": `Lorem ipsum dolor, sit amet consectetur adipisicing elit. Quis sapiente 
    laborum cupiditate possimus labore, hic temporibus velit dicta earum
    suscipit commodi eum enim atque at? Et perspiciatis dolore iure
    voluptatem.`,
    "link": "https://github.com/pennhanlee/inzaghi"
}, {
    "title": "Scholarsheep, a Quiz Trivia Web Application",
    "content": `Lorem ipsum dolor, sit amet consectetur adipisicing elit. Quis sapiente 
    laborum cupiditate possimus labore, hic temporibus velit dicta earum
    suscipit commodi eum enim atque at? Et perspiciatis dolore iure
    voluptatem.`,
    "link": "https://github.com/pennhanlee/scholarsheep"
}]